import { PageLayout } from "@/components/PageLayout";
import { PageHero, SectionCTA } from "@/components/PageHero";
import { Visit as VisitSection } from "@/components/Visit";

const Visit = () => (
  <PageLayout testId="visit-page">
    <PageHero
      eyebrow="Find Us"
      title="Pull"
      accent="Up"
      breadcrumb="Visit"
      subtitle="Memphis: 3711 Lamar Avenue · West Memphis: 109 S Worthington Drive · Memphis (901) 623-7196 · Arkansas (870) 394-4229 · Mon–Fri 10A–10P · Sat 12P–10P · Sun Closed. Walk in, call ahead, or tap DoorDash for delivery."
      bg="/assets/photos/IMG_3383.jpeg"
    />
    <VisitSection />
    <section className="bg-[#1A1A1A] border-t border-[#222] py-14">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <h3 className="font-heading text-3xl sm:text-4xl text-white mb-6">
          Skip The Wait · <span className="text-[#E60000]">Order Online</span>
        </h3>
        <div className="flex flex-wrap justify-center gap-3">
          <SectionCTA to="/menu" label="Order Pickup / Delivery" />
        </div>
      </div>
    </section>
  </PageLayout>
);

export default Visit;
